import { Component, inject, OnInit, signal } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { PageHeader } from '../../../../shared/components/page-header/page-header';
import { PlansService } from '../../../../shared/services/plans.service';
import { LandingService } from '../../../../shared/services/landing.service';

@Component({
  selector: 'app-policy-privacy-page',
  imports: [PageHeader],
  templateUrl: './policy-privacy-page.html',
  styleUrl: './policy-privacy-page.scss',
})
export class PolicyPrivacyPage implements OnInit {
  breadcrumbs = [
    { label: 'Home', route: '/' },
    { label: 'Política de privacidad', route: '/policy-privacy', isActive: true },
  ];

  activeRoute = inject(ActivatedRoute);
  plansService = inject(PlansService);
  landingService = inject(LandingService);

  sanitizer = inject(DomSanitizer);

  planId = signal<string | null>(null);
  planTitle = signal<string | null>(null);
  policyHtml = signal<SafeHtml | null>(null);

  isWithPlanId = signal<boolean>(false);

  async ngOnInit(): Promise<void> {
    this.planId.set(this.activeRoute.snapshot.paramMap.get('planId') || null);

    this.isWithPlanId.set(!!this.planId());

    if (this.isWithPlanId()) {
      await this.loadPolicy();
    } else {
      await this.loadPolicyGeneral();
    }
  }

  async loadPolicy() {
    if (this.planId()) {
      const plan = await this.plansService.getPlanById(this.planId()!);
      this.planTitle.set(plan.title);
      this.policyHtml.set(
        this.sanitizer.bypassSecurityTrustHtml(this.normalizeHtml(plan.policy_html.content))
      );
    }
  }

  async loadPolicyGeneral() {
    const policy = await this.landingService.getPolicyFromApi();
    this.policyHtml.set(
      this.sanitizer.bypassSecurityTrustHtml(this.normalizeHtml(policy.data.content))
    );

    this.planTitle.set(policy.data.title);
  }

  /**
   * Normaliza el HTML del backend: reemplaza los espacios no separables (&nbsp;)
   * por espacios normales. Con &nbsp; en cada espacio el navegador no encuentra
   * dónde quebrar línea y termina rompiendo a mitad de palabra.
   */
  private normalizeHtml(html: string): string {
    return (html || '').replace(/&nbsp;/g, ' ');
  }
}
